export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fornecedor' */ '@/views/web-service/almoxarifado/cliente/fornecedor/Index'),
        path: 'almoxarifado-cliente-fornecedor',
        redirect: 'almoxarifado-cliente-fornecedor/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fornecedor' */'@/views/web-service/almoxarifado/cliente/fornecedor/List.vue'),
                name: 'web-service-almoxarifado-cliente-fornecedor-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fornecedor' */ '@/views/web-service/almoxarifado/cliente/fornecedor/Form.vue'),
                name: 'web-service-almoxarifado-cliente-fornecedor-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fornecedor' */ '@/views/web-service/almoxarifado/cliente/fornecedor/Form.vue'),
                name: 'web-service-almoxarifado-cliente-fornecedor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]